module.exports = __webpack_public_path__ + "img/icon-anti-delete.37b09ce8.svg";